import { Card } from 'antd'
import React from 'react'
import LoginForm from './LoginForm/LoginForm'
import MemberRegisterPromo from '../register/MemberRegisterPromo/MemberRegisterPromo'

const LoginPage = () => {
	return (
		<div className="login-container register-container">
			<div className="mobile">
				<MemberRegisterPromo isLogin />
			</div>
			<Card bordered={false} className="login-card register-card">
				<LoginForm />
			</Card>
			<div className="desktop">
				<MemberRegisterPromo isLogin />
			</div>
		</div>
	)
}

export default LoginPage
